import { gql } from "@apollo/client";

export const CALL = gql`
    query queryCall($id: Float!) {
        call(id: $id) {
            id
            items
            patient {
                id
                name
                region
                city
                rg
                cpf
                birth_date
                age
            }
            mission {
                name
                city
                start_date
                end_date
            }
            user {
                id
                name
                notes
            }
        }
    }
`;

export default CALL;
